module.exports = __webpack_public_path__ + "img/destroyer-robot.ba3fd502.png";